import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../../shared/components/Dropdown/Dropdown';


const DropdownVariants = function DropdownVariantsComponent({
  variationGroup, handleDropownChange,
}) {
  let selectedValue = '';
  const options = variationGroup.values.sort((valueA, valueB) => valueA.value - valueB.value)
    .map(({
      value,
      selected,
      selectable,
      displayValue: label,
    }) => {
      if (selected) {
        selectedValue = value;
      }
      return {
        label,
        value,
        selected,
        disabled: !selectable,
      };
    });

  return (
    <fieldset key={variationGroup.id} className="product-details__variation-group">
      <legend className="product-details__variation-group__title">{variationGroup.displayName}</legend>
      <Dropdown
        theme="form"
        options={options}
        disabledMsg="out of stock"
        fieldName={variationGroup.attributeId}
        selectedValue={selectedValue}
        onChange={event => handleDropownChange(event, variationGroup)}
      />
    </fieldset>
  );
};

DropdownVariants.propTypes = {
  variationGroup: PropTypes.shape({}).isRequired,
  handleDropownChange: PropTypes.func.isRequired,
};

export default DropdownVariants;
